/* eslint-disable camelcase */
import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { v4 as uuid } from "uuid";
import { isEmpty } from "lodash-es";

import {
  Row,
  Column,
  Container,
  Loader,
  ActionBar,
  Heading,
  Details,
  DetailsItem,
  PictureGallery,
  DetailsHeaderItem,
  DetailsPicture,
  ActionBarButtons,
  EditActionButton,
  DeleteActionButton,
  withApi,
  withUser,
  withBrowser,
  withAccessRights,
  apiShape,
  accessRightsShape,
  intlShape,
  browserShape,
  withNotifier,
  notifierShape,
  formatAddress,
  removeNullAttributes,
} from "lcm-iot-commons";

export function extractInitialValues(response: $TSFixMe) {
  const initialValues = { ...response };
  const address = {
    firstName: response.address?.first_name,
    lastName: response.address?.last_name,
    streetName: response.address?.street,
    streetNumber: response.address?.street_number,
    zipCode: response.address?.zip_code,
    regionCode: response.address?.region_code,
    city: response.address?.city,
    phone: response.address?.phone,
    countryCode: response.address?.country_code,
    countryName: response.address?.country_name,
  };
  initialValues.address = removeNullAttributes(address);
  return initialValues;
}

type Props = {
  api: apiShape;
  intl: intlShape;
  browser: browserShape;
  accessRights: accessRightsShape;
  notifier: notifierShape;
  match: {
    params?: {
      id?: string;
      resellerCustomerId?: string;
    };
  };
};

export function ResellerCustomerDetails(props: Props) {
  const { api, browser, accessRights, match, intl, notifier } = props;
  // @ts-expect-error TS(2339) FIXME: Property 'id' does not exist on type '{ id?: strin... Remove this comment to see the full error message
  const { id } = match.params;
  const [customer, setCustomer] = useState([]);

  const loadData = async () => {
    try {
      const response = await api.get(
        `/customers/${id}`,
        { include: "address" },
        false,
      );
      // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 2.
      setCustomer(extractInitialValues(response, accessRights));
    } catch (error) {
      notifier.showError(api.translateError(error));
      // @ts-expect-error TS(2345) FIXME: Argument of type '{}' is not assignable to paramet... Remove this comment to see the full error message
      setCustomer({});
    }
  };
  React.useEffect(() => {
    loadData();
  }, [id]);

  const onConfirmDelete = async () => {
    try {
      await api.delete(`/customers/${id}`);
      notifier.showSuccess(
        intl.formatMessage({ id: "reseller_customer.delete.notification" }),
      );
      browser.navigateTo("/reseller/customers");
    } catch (error) {
      notifier.showError(api.translateError(error));
    }
  };

  return (
    <Container>
      <Row>
        <Column>
          <ActionBar>
            <Heading
              title={intl.formatMessage({
                id: "reseller_customer.details.header",
              })}
            />
            <ActionBarButtons>
              <EditActionButton
                id="edit-customer-button"
                disabled={!accessRights.canUpdate}
                target={`/reseller/customers/${id}/edit`}
              />
              <DeleteActionButton
                id="delete-customer-button"
                disabled={!accessRights.canDelete}
                modalTitle={intl.formatMessage({
                  id: "reseller_customer.delete.modal_title",
                })}
                modalMessage={intl.formatMessage({
                  id: "reseller_customer.delete.modal_message",
                })}
                onConfirm={onConfirmDelete}
              />
            </ActionBarButtons>
          </ActionBar>
          {customer && (
            <Details>
              <DetailsPicture>
                <PictureGallery placeholder="lcm-iot-icon-user icon" />
              </DetailsPicture>
              <DetailsHeaderItem
                id="company"
                translationKey="label.account"
                value={(customer as $TSFixMe).name}
              />
              <DetailsHeaderItem
                id="number"
                translationKey="label.number"
                value={(customer as $TSFixMe).number}
              />
              {!isEmpty((customer as $TSFixMe).address) && (
                <Details>
                  <DetailsItem
                    id="customer-address"
                    translationKey="label.address"
                  >
                    <ul className="shipping-billing-address">
                      {formatAddress((customer as $TSFixMe).address).map(
                        (line: $TSFixMe) => (
                          <li className="shipping-billing-line" key={uuid()}>
                            {line}
                          </li>
                        ),
                      )}
                    </ul>
                  </DetailsItem>
                </Details>
              )}
            </Details>
          )}
          <Loader id="loader" loading={!customer} />
        </Column>
      </Row>
    </Container>
  );
}

export default withBrowser(
  withNotifier(
    withApi(
      withUser(
        // @ts-expect-error TS(2345) FIXME: Argument of type 'FC<WithIntlProps<Readonly<Omit<P... Remove this comment to see the full error message
        injectIntl(withAccessRights(ResellerCustomerDetails, "Customer")),
      ),
    ),
  ),
);
